import { useKeyboardShortcut } from "../hooks/useKeyboardShortcut";

type Props = {
  shortcut: string | string[];
  handler: (e: KeyboardEvent) => void;
  children: JSX.Element;
  bindTo?: React.MutableRefObject<HTMLElement | null | undefined>;
};

function KeyboardShortcut({ shortcut, handler, children, bindTo }: Props) {
  useKeyboardShortcut(shortcut, handler, { bindTo });
  return children;
}

export { KeyboardShortcut };
